<div>
  <app-custom-toast></app-custom-toast>
  <p-tabs value="0">
    <p-tablist>
      <p-tab
        value="0"
        [style]="{ '--badge-display': unseenNotifCount > 0 ? 'block' : 'none' }"
      >
        @if (unseenNotifCount > 0) {
          <p-overlaybadge severity="danger">
            <span>اعلان‌ها</span>
          </p-overlaybadge>
        } @else {
          <span>اعلان‌ها</span>
        }
      </p-tab>
      <p-tab
        value="1"
        [style]="{
          '--badge-display': unseenMessageCount > 0 ? 'block' : 'none',
        }"
      >
        @if (unseenMessageCount > 0) {
          <p-overlaybadge severity="danger">
            <span>پیام‌ها</span>
          </p-overlaybadge>
        } @else {
          <span>پیام‌ها</span>
        }
      </p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div
          class="flex flex-col items-stretch w-96"
          style="height: 380px"
          #scrollRoot
        >
          <app-infinite-list
            class="h-0 grow overflow-y-auto"
            [items]="notifications.results"
            [initialPage]="1"
            [initialHasNext]="notifications.next?.length"
            [sortFn]="notifSortFn"
            [fetchPage]="fetchNotificationsPage"
            (itemsChange)="onNotifItemsChange($event)"
            [root]="scrollRoot"
          >
            <div infiniteListEmpty *ngIf="notifications.results.length === 0">
              <div class="text-center text-gray-500 mt-5">
                هیچ اعلانی جهت نمایش وجود ندارد.
              </div>
            </div>

            <ng-template appInfiniteListItem let-notif let-i="index">
              <div
                class="m-2 mx-3 mb-4"
                [ngClass]="!notif.seen ? 'unseen-item' : ''"
              >
                <div
                  class="flex items-center cursor-pointer"
                  [ngClass]="notif.seen ? 'text-gray-500 opacity-50' : ''"
                >
                  <h6
                    class="font-bold m-0 mb-2"
                    (click)="openNotification(notif)"
                  >
                    {{ notif.title }}
                  </h6>
                  <div class="mr-auto flex">
                    <button
                      class="notif-action border-0 block"
                      type="button"
                      (click)="deleteNotification(notif)"
                    >
                      <i class="fa fa-trash-alt text-gray-800"></i>
                    </button>
                    <div class="ms-1"></div>
                    <button
                      class="notif-action border-0 block"
                      type="button"
                      (click)="markNotificationSeen(notif)"
                      *ngIf="!notif.seen"
                    >
                      <i
                        class="fa fa-check-double"
                        [ngClass]="
                          notif.seen ? 'text-green-500' : 'text-gray-800'
                        "
                      ></i>
                    </button>
                  </div>
                </div>
                <div
                  class="text-gray-500 line-4 text-justify"
                  [ngClass]="notif.seen ? 'text-gray-500 opacity-50' : ''"
                >
                  {{ notif.message }}
                </div>
                <div
                  class="text-gray-500 text-xs mt-1"
                  [ngClass]="notif.seen ? 'text-gray-500 opacity-50' : ''"
                >
                  {{ notif.create_time! | stringToDate | dateToJalali }}
                </div>
              </div>
            </ng-template>
          </app-infinite-list>
          <div class="border-t"></div>
          <div class="flex items-center btn-group mx-2 mt-1">
            <div class="flex items-center">
              <span class="text-gray-500"> خوانده نشده:</span>
              <b> {{ unseenNotifCount }} &nbsp; </b>
              <span class="text-gray-500"> تعداد: </span>
              <b>
                {{ notifications.count }}
              </b>
            </div>
            <div class="mr-auto">
              <button
                class="notif-action"
                type="button"
                (click)="deleteAllNotifications()"
              >
                <i class="fa fa-trash-alt text-gray-800"></i>
              </button>
              <button
                class="notif-action ms-1"
                type="button"
                (click)="seeAllNotifications()"
              >
                <i class="fa fa-check-double text-gray-800"></i>
              </button>
            </div>
          </div>
        </div>
      </p-tabpanel>
      <p-tabpanel value="1">
        <div class="flex flex-col items-stretch w-96" style="height: 380px">
          <app-infinite-list
            class="h-0 grow overflow-y-auto"
            [items]="messages.results"
            [initialPage]="1"
            [initialHasNext]="messages.next?.length"
            [sortFn]="messageSortFn"
            [fetchPage]="fetchMessagesPage"
            (itemsChange)="onMessageItemsChange($event)"
          >
            <div infiniteListEmpty *ngIf="messages.results.length === 0">
              <div class="text-center text-gray-500 mt-5">
                هیچ پیامی جهت نمایش وجود ندارد.
              </div>
            </div>

            <ng-template appInfiniteListItem let-message let-i="index">
              <div
                class="m-2 mx-3 mb-4"
                [ngClass]="!message.seen ? 'unseen-item' : ''"
              >
                <div class="flex items-center cursor-pointer">
                  <h6
                    class="font-bold m-0 mb-2"
                    (click)="openMessage(message)"
                    [ngClass]="message.seen ? 'text-gray-500 opacity-50' : ''"
                  >
                    {{ message.title }}
                  </h6>
                  <div class="mr-auto flex">
                    <button
                      class="notif-action border-0 block"
                      type="button"
                      (click)="deleteMessage(message)"
                    >
                      <i class="fa fa-trash-alt text-gray-800"></i>
                    </button>
                    <div class="ms-1"></div>
                    <button
                      class="notif-action border-0 block"
                      type="button"
                      (click)="markMessageAsSeen(message)"
                      *ngIf="!message.seen"
                    >
                      <i
                        class="fa fa-check-double"
                        [ngClass]="
                          message.seen ? 'text-green-500' : 'text-gray-800'
                        "
                      ></i>
                    </button>
                  </div>
                </div>
                <div
                  class="text-gray-500 line-2 text-justify cursor-pointer"
                  [ngClass]="message.seen ? 'text-gray-500 opacity-50' : ''"
                  (click)="openMessage(message)"
                >
                  {{ message.body | extractHtmlText }}
                </div>
                <div
                  class="text-gray-500 text-xs mt-1"
                  [ngClass]="message.seen ? 'text-gray-500 opacity-50' : ''"
                >
                  {{ message.create_time | stringToDate | dateToJalali }}
                </div>
              </div>
            </ng-template>
          </app-infinite-list>
          <div class="border-t"></div>
          <div class="flex items-center btn-group mx-2 mt-1">
            <div class="flex items-center">
              <span class="text-gray-500"> خوانده‌نشده:</span>
              <span class="font-bold"> {{ unseenMessageCount }} &nbsp; </span>
              <span class="text-gray-500"> تعداد: </span>
              <span class="font-bold">
                {{ messages.count }}
              </span>
            </div>
            <div class="mr-auto">
              <button
                class="notif-action"
                type="button"
                (click)="deleteAllMessages()"
              >
                <i class="fa fa-trash-alt text-gray-800"></i>
              </button>
              <button
                class="notif-action ms-1"
                type="button"
                (click)="seeAllMessages()"
              >
                <i class="fa fa-check-double text-gray-800"></i>
              </button>
            </div>
          </div>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
